import { Lightning } from '@lightningjs/sdk';
import Sparkline from './sparkline.component';

/**
 * One metric: its name on the left, the current reading on the right, and the strip underneath.
 *
 * Each row owns its own geometry, which is why the layout no longer depends on guessing how tall a shared block of
 * text renders — that guess is what used to let the readout overlap the first graph.
 */
export default class MetricRow extends Lightning.Component {
  static _template() {
    return {
      Name: {},
      Value: {},
      Graph: {
        type: Sparkline,
      },
    };
  }

  /**
   * @param {Object} value `{ label, w, fontSize, headerHeight, graphHeight, samples, barWidth, max, color }`
   */
  set config({ label, w, fontSize, headerHeight, graphHeight, samples, barWidth, max, color }) {
    // NOTE: lineHeight stays at the font size — see TEXT_HEIGHT_RATIO for why it must not be the allocation
    const header = {
      fontSize,
      lineHeight: fontSize,
      wordWrap: false,
      textColor: color,
    };

    this._header = header;

    this.patch({
      w,
      h: headerHeight + graphHeight,
      Name: {
        text: { ...header, text: label },
      },
      Value: {
        // Anchored to the right edge, so a longer reading grows towards the name instead of past the box
        mountX: 1,
        x: w,
        text: { ...header },
      },
      Graph: {
        y: headerHeight,
        config: { samples, barWidth, h: graphHeight, max, color },
      },
    });
  }

  /**
   * NOTE: TextTexture compares before it invalidates, so a reading that has not moved costs nothing here
   *
   * @param {string} value the reading to display
   */
  set value(value) {
    this.tag('Value').text = { text: value };
  }

  set valueColor(color) {
    this.tag('Value').text = { textColor: color };
  }

  push(sample) {
    this.tag('Graph').push(sample);
  }
}
